import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconInfo = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#b5b9bc"} className={`info ${props.className}`} viewBox="0 0 24 24">
        <polygon fill="#ffffff" points="0 0 24 0 24 24 0 24"></polygon>
        <path fill={props.fill ? props.fill : "#b5b9bc"} d="M11,7 L13,7 L13,9 L11,9 L11,7 Z M11,11 L13,11 L13,17 L11,17 L11,11 Z M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z" fill-rule="nonzero"></path>
    </IconWrapper>
);

export default memo(IconInfo);
